import React from 'react'
import { useTranslation } from 'react-i18next'
import { UploadQuestionTooltip } from 'ui/shorthands/QuestionTooltip'
import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'
import { SelectOptionsProps } from 'types/med'

const useStyles = makeStyles()((theme: Theme) => ({
  leftParentheses: {
    display: 'inline-block',
    marginLeft: '-0.5em',
  },
  requiredLabel: {
    display: 'inline-block',
    paddingTop: 4,
    paddingLeft: theme.spacing(1),
    fontSize: 12,
    color: theme.palette.secondary.main,
    letterSpacing: 1,
    whiteSpace: 'nowrap',
    marginLeft: '-0.5em',
  },
}))

export const UploadLabel = (
  label: React.ReactNode,
  optional?: SelectOptionsProps
) => {
  return (
    <>
      {optional ? (
        <LabelWithStatus status={optional}>{label}</LabelWithStatus>
      ) : (
        label
      )}
      <UploadQuestionTooltip />
    </>
  )
}

export const LabelWithStatus: React.FC<{
  children: any
  status?: SelectOptionsProps
}> = ({ children, status }) => {
  const { t } = useTranslation()
  const { classes } = useStyles()
  if (status === 'optional') {
    return (
      <>
        {children}
        <span className={classes.leftParentheses}>（{t('任意')}）</span>
      </>
    )
  }
  if (status === 'required') {
    return (
      <>
        {children}
        <span className={classes.requiredLabel}>{t('*必須')}</span>
      </>
    )
  }
  return children
}

export type RequiredLabelProps = {
  children: any
  optional: SelectOptionsProps
}

export const RequiredLabel: React.FC<RequiredLabelProps> = ({
  children,
  optional,
}: RequiredLabelProps) => {
  const { t } = useTranslation()
  const { classes } = useStyles()
  return optional === 'optional' ? (
    <span>
      {children}
      <span className={classes.leftParentheses}>（{t('任意')}）</span>
    </span>
  ) : (
    <>{children}</>
  )
}
